import React from 'react';
import { Button } from '@whalecloud/fdx';

const ButtonContainer = props => {
  const { getAllClasses, elementStyle, element } = props;
  const { type = 'default', className = '' } = element.data || {};

  const { formItemSettings, formSettings } = element.data || {};
  const { text, icon, ...restProps } = formItemSettings;

  return (
    <div
      style={elementStyle}
      className={getAllClasses(
        'webiny-pb-page-element-button',
        'webiny-pb-page-element-button--' + type
      )}
      {...formSettings}
    >
      <Button {...restProps} className={className}>{icon && <span>{icon}</span>}{text}</Button>
    </div>
  );
};

export default ButtonContainer;
